module.exports = __webpack_public_path__ + "static/media/rain.cf76670f.png";